import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseService } from '../../../shared/services/base.service';
import { environment } from '../../../../../environments/environment';
import { SummaryBankAccountModel } from '../models/summary-bank-account.model';
import { PaginableResponseModel } from '../../../common/models/paginable-response.model';

@Injectable({ providedIn: 'root' })
export class BankAccountService extends BaseService<SummaryBankAccountModel, SummaryBankAccountModel> {
  private fullUrl = `${environment.apiUrl}/api/v2/bank-accounts`;

  constructor(http: HttpClient) {
    super(http, '/api/v2/bank-accounts');
  }

  getSummaryList(filter: any): Observable<PaginableResponseModel<SummaryBankAccountModel>> {
    return this.http.post<PaginableResponseModel<SummaryBankAccountModel>>(
      `${this.fullUrl}/list`, filter);
  }
}
